import {
  SeasonFighterFrequency,
  SeasonUsersTotalPoints,
  UserSeason,
  UserSeasonFighter,
} from '../../domain/models/userSeason.model';
import { Action } from '../action.type';

export const RETRIEVE_USER_SEASON = 'RETRIEVE_USER_SEASON';
export const RETRIEVE_USER_SEASON_SUCCESS = 'RETRIEVE_USER_SEASON_SUCCESS';
export const RETRIEVE_USER_SEASON_FAILURE = 'RETRIEVE_USER_SEASON_FAILURE';
export const UPSERT_USER_SEASON = 'UPSERT_USER_SEASON';
export const UPSERT_USER_SEASON_SUCCESS = 'UPSERT_USER_SEASON_SUCCESS';
export const UPSERT_USER_SEASON_FAILURE = 'UPSERT_USER_SEASON_FAILURE';
export const RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON =
  'RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON';
export const RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON_SUCCESS =
  'RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON_SUCCESS';
export const RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON_FAILURE =
  'RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON_FAILURE';
export const RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON =
  'RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON';
export const RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON_SUCCESS =
  'RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON_SUCCESS';
export const RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON_FAILURE =
  'RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON_FAILURE';

export type RetrieveUserSeasonPayload = {
  retry: number;
  token: string;
  seasonId: string;
};

export type UpsertUserSeasonPayload = {
  retry: number;
  token: string;
  seasonId: string;
  fighters: UserSeasonFighter[];
};

export type RetrieveUserSeasonSuccessPayload = {
  userSeason: UserSeason;
  lastUpdated: number;
};

export type UpsertUserSeasonSuccessPayload = {
  userSeason: UserSeason;
  lastUpdated: number;
};

export type RetrieveFighterFrequencyBySeasonPayload = {
  retry: number;
  token: string;
  seasonId: string;
};

export type RetrieveFighterFrequencyBySeasonSuccessPayload = {
  fighterFrequency: SeasonFighterFrequency;
};

export type RetrieveUsersTotalPointsBySeasonPayload = {
  retry: number;
  token: string;
  seasonId: string;
  limit: number;
};

export type RetrieveUsersTotalPointsBySeasonSuccessPayload = {
  usersTotalPoints: SeasonUsersTotalPoints;
};

export interface RetrieveUserSeason extends Action<RetrieveUserSeasonPayload> {
  type: typeof RETRIEVE_USER_SEASON;
  payload: RetrieveUserSeasonPayload;
}

export interface RetrieveUserSeasonSuccess
  extends Action<RetrieveUserSeasonSuccessPayload> {
  type: typeof RETRIEVE_USER_SEASON_SUCCESS;
  payload: RetrieveUserSeasonSuccessPayload;
}

export interface RetrieveUserSeasonFailure extends Action<string> {
  type: typeof RETRIEVE_USER_SEASON_FAILURE;
  payload: string;
}

export interface UpsertUserSeason extends Action<UpsertUserSeasonPayload> {
  type: typeof UPSERT_USER_SEASON;
  payload: UpsertUserSeasonPayload;
}

export interface UpsertUserSeasonSuccess
  extends Action<UpsertUserSeasonSuccessPayload> {
  type: typeof UPSERT_USER_SEASON_SUCCESS;
  payload: UpsertUserSeasonSuccessPayload;
}

export interface UpsertUserSeasonFailure extends Action<string> {
  type: typeof UPSERT_USER_SEASON_FAILURE;
  payload: string;
}

export interface RetrieveFighterFrequencyBySeason
  extends Action<RetrieveFighterFrequencyBySeasonPayload> {
  type: typeof RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON;
  payload: RetrieveFighterFrequencyBySeasonPayload;
}

export interface RetrieveFighterFrequencyBySeasonSuccess
  extends Action<RetrieveFighterFrequencyBySeasonSuccessPayload> {
  type: typeof RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON_SUCCESS;
  payload: RetrieveFighterFrequencyBySeasonSuccessPayload;
}

export interface RetrieveFighterFrequencyBySeasonFailure
  extends Action<string> {
  type: typeof RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON_FAILURE;
  payload: string;
}

export interface RetrieveUsersTotalPointsBySeason
  extends Action<RetrieveUsersTotalPointsBySeasonPayload> {
  type: typeof RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON;
  payload: RetrieveUsersTotalPointsBySeasonPayload;
}

export interface RetrieveUsersTotalPointsBySeasonSuccess
  extends Action<RetrieveUsersTotalPointsBySeasonSuccessPayload> {
  type: typeof RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON_SUCCESS;
  payload: RetrieveUsersTotalPointsBySeasonSuccessPayload;
}

export interface RetrieveUsersTotalPointsBySeasonFailure
  extends Action<string> {
  type: typeof RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON_FAILURE;
  payload: string;
}
